export default class SectionIntersectionView {
  intersections: string[] = []
  private visibleSections: Record<string, boolean> = {}
  private io!: IntersectionObserver

  constructor(intersections: string[] = []) {
    this.intersections = intersections
    this.initIntersectionObserver()
  }

  initIntersectionObserver() {
    this.io = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          this.isSectionIntersecting((entry.target as HTMLElement).dataset.section || '', entry.isIntersecting)
          if (entry.intersectionRatio == 0) return
        })
      },
      { rootMargin: '-150px 0px -200px 0px' }
    )
    this.intersections.forEach(section => {
      const $section = document.querySelector(`#section-${section}`)
      if ($section) {
        this.io.observe($section)
      }
    })
  }

  isSectionIntersecting(section: string, isIntersecting: boolean) {
    const $navItem = document.querySelector(`#section-nav-${section}`)
    if (!$navItem) return
    this.visibleSections[section] = isIntersecting
    this.setNavMarker()
  }

  setNavMarker() {
    let top = 0
    let height = 0
    Object.keys(this.visibleSections).every(sec => {
      const navItem = document.getElementById('section-nav-' + sec) as HTMLElement
      if (!navItem) return false
      if (!this.visibleSections[sec] && height > 0) return false
      if (this.visibleSections[sec]) height += navItem.scrollHeight
      else top += navItem.scrollHeight || 0
      return true
    })
    const markerStyle = (document.getElementById('section-nav-marker') as HTMLElement).style
    markerStyle.transform = `translateY(${top}px)`
    markerStyle.height = height + 'px'
  }

  reset(sections: string[]) {
    this.io.disconnect()
    if (sections) {
      this.intersections = sections
    }
    this.visibleSections = {}
    this.initIntersectionObserver()
  }
}
